import { render, staticRenderFns } from "./Disorder.vue?vue&type=template&id=05913a94"
import script from "./Disorder.vue?vue&type=script&lang=js"
export * from "./Disorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports